import { Component } from '@angular/core';

import { ProfileService } from '../profile.service';
import { ViewProfileService } from './view-profile/view-profile.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  providers: [ProfileService, ViewProfileService],
})
export class UserProfileComponent {}
